interface PaginationProps {
  current: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    if (i === 1 || i === totalPages || Math.abs(i - current) <= 1) {
      pages.push(i);
    }
  }

  return (
    <nav className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className="flex h-9 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 text-sm font-semibold text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {pages.map((page, i) => {
        const prev = pages[i - 1];
        const showEllipsis = prev && page - prev > 1;
        return (
          <span key={page} className="flex items-center gap-2">
            {showEllipsis && <span className="text-foreground-400">···</span>}
            <button
              type="button"
              onClick={() => onChange(page)}
              className={`h-9 min-w-[36px] cursor-pointer rounded-md px-3 text-sm font-semibold transition-colors ${
                page === current
                  ? "bg-primary-500 text-background-50"
                  : "border border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              {page}
            </button>
          </span>
        );
      })}

      <button
        type="button"
        disabled={current === totalPages}
        onClick={() => onChange(current + 1)}
        className="flex h-9 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 text-sm font-semibold text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}